export const ticketKeys = {
  all: ['tickets'] as const,
  list: (params: Record<string, unknown>) => [...ticketKeys.all, 'list', params] as const,
  detail: (id: string) => [...ticketKeys.all, 'detail', id] as const,
  activity: (id: string, params: Record<string, unknown>) =>
    [...ticketKeys.all, 'activity', id, params] as const,
  reporters: () => [...ticketKeys.all, 'reporters'] as const,
  investigations: (ticketId: string) => [...ticketKeys.all, 'investigations', ticketId] as const,
  investigation: (ticketId: string, invId: string) =>
    [...ticketKeys.all, 'investigations', ticketId, invId] as const,
}

export const trackerKeys = {
  all: ['tracker'] as const,
  // Bare prefixes for invalidation — narrower than `all`, which also matches
  // the enablement probe (['tracker','enabled',…]) and the categories cache
  // (['tracker','categories',…]). A promote/demote/status/tracker-patch
  // mutation should refetch lists and details, never those two.
  lists: ['tracker', 'list'] as const,
  list: (params: Record<string, unknown>) => [...trackerKeys.all, 'list', params] as const,
  details: ['tracker', 'detail'] as const,
  detail: (id: string) => [...trackerKeys.all, 'detail', id] as const,
  categories: (companyId?: string, asUser?: string) =>
    [...trackerKeys.all, 'categories', companyId ?? null, asUser ?? null] as const,
  // Bare prefix, same reasoning as lists/details: an in-call edit from the
  // presentation deck invalidates every presentation cache entry (whichever
  // companyId/includeClosed/asUser combination is mounted) without also
  // touching the enablement probe or categories cache.
  presentations: ['tracker', 'presentation'] as const,
  // includeClosed lives in the key like every other param here: toggling it
  // must refetch, not serve the closed-excluded page's cache entry. Same for
  // the carried list filters (design doc "Presenting follows the list's
  // filters", 2026-08-24) — a filtered and an unfiltered deck must never
  // share a cache entry, so status/priority/q live in the key too.
  presentation: (
    companyId?: string,
    includeClosed?: boolean,
    asUser?: string,
    filters?: { status?: string; priority?: string; q?: string },
  ) =>
    [
      ...trackerKeys.all,
      'presentation',
      companyId ?? null,
      Boolean(includeClosed),
      asUser ?? null,
      filters?.status ?? null,
      filters?.priority ?? null,
      filters?.q ?? null,
    ] as const,
}

// Kept apart from ticketKeys so a ticket mutation's ticketKeys.all
// invalidation never refetches whatever search box happens to be open.
export const peopleKeys = {
  users: (q: string, companyId?: string) => ['people', 'users', q, companyId ?? null] as const,
  companies: (q: string) => ['people', 'companies', q] as const,
}
